










import { apiV1AdminApplicantsPath } from '@/rails/routes'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import Applicant, { IApplicant} from '@/models/Applicant'
import ApplicantList from '@/components/admin/applicants/List.vue'

@Component(
  {
    components: {
      ApplicantList
    }
  }
)
export default class ApplicantIndex extends PageBase {
  applicants: Array<Applicant> = []
  keyword = ''
  edit = new Applicant()
  editMemo = null
  showedEditMemo = false

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '応募一覧'
      }
    ]
  }

  get viewApplicants(): Array<Applicant> {
    if (this.keyword) {
      const keyword = this.keyword.toLocaleLowerCase()
      return this.applicants.filter(
        applicant => applicant.memo.toLocaleLowerCase().includes(keyword) ||
          applicant.user.name.toLocaleLowerCase().includes(keyword) ||
          applicant.recruit.title.toLocaleLowerCase().includes(keyword)
      )
    }
    return this.applicants
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const res = await axios.get<Array<IApplicant>>(apiV1AdminApplicantsPath())
      this.applicants = res.data.map(a => new Applicant(a))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }
}
